import React, { useRef } from 'react';
import ModalWrapper from '../ModalWrapper';
import CommonFooter from '../FormComponent/CommonFooter';
import { FormSchemas, FormWrapper } from '../FormComponent';


const AddModuleModal = ({ isOpen, onClose, onConfirm, title='Add New Module' }) => {
  const formRef = useRef(null);
  
  const handleConfirmAdd = (data) => {
    const moduleName = data.moduleName;
    const context = data.moduleContext;
    if (moduleName) {
      onConfirm(moduleName, context); 
      onClose();
    }
  };
  const handleFormSubmit = async () => {
    if (formRef.current) await formRef.current.submit();
  };
  const buttons = [
    {
      label: 'Cancel',
      variant: 'outline',
      className: 'primary',
      onClick: onClose,
    },
    {
      label: 'Create',
      variant: 'primary',
      className: 'white bg-blue600',
      onClick: handleFormSubmit,
    },
  ];

  const fields = [
    {
      name: 'moduleName',
      type: 'text',
      label: 'Name',
      placeholder: 'Enter your full module name',
      required: true,
    },
    {
      name: 'moduleContext',
      type: 'text',
      label: 'Context',
      placeholder: 'Enter your context',
      multiline: true,
      rows: 4
    },
  ]

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="small"
      footer={
        <CommonFooter
          buttons={buttons}
          align="right"
        />
      }
      children={
        <FormWrapper
          ref={formRef}
          schema={FormSchemas.moduleForm}
          fields={fields}
          onSubmit={handleConfirmAdd}
          defaultValues={{
            moduleName: '',
            moduleContext: ''
          }}
        />
      }
    />
  );
};

export default AddModuleModal;